<div class="modal-header">
    <h5 class="modal-title">Select Media</h5>
    <button type="button" class="close" (click)="activeModal.close()">
        <span>×</span>
    </button>
</div>
<div class="modal-body">
    <app-media-library [isModal]="true" [folders]="folders"></app-media-library>
</div>
<div class="modal-footer">
    <button class="btn btn-primary btn-sm" (click)="select()">Ok</button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="activeModal.close()">Cancel</button>
</div>
